import { Grid, Row, Col, Button, Modal } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from "react-redux";

import { setData } from "../../redux/actionCreators";
import saModalCloseImg from './../../resources/images/times-circle-solid.svg';
import saUniqueKeyImage from './../../resources/images/unique_key_description.svg';
import saQuestionsCheckImage from './../../resources/images/checklist.svg';
import claveUnicaLogo from './../../resources/images/claveunica.svg';
import './selectAuthenticationTypeClaveUnicaPriority.css';
import AM from '../../config/authenticationMethods';
import { setErrorMessage, setErrorType, setShowError } from "../../redux/actionCreators";

class SelectAuthenticationTypeClaveUnicaPriority extends Component {

    CLAVE_UNICA_LOGIN = 'CLAVE_UNICA_LOGIN';

    constructor(props) {
        super(props);
        this.VALID_VALUES = [AM.QUESTIONS_AUTH, this.CLAVE_UNICA_LOGIN, AM.QUESTIONS_AUTH];
        this.initModals = this.initModals.bind(this);
        this.state = {
            showModals: this.initModals()
        };
        this.onClickModalTrigger = this.onClickModalTrigger.bind(this);
        this.triggerQuestions = this.triggerQuestions.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.loginClaveUnica = this.loginClaveUnica.bind(this);

        this.modalsInfo = {
            [AM.QUESTIONS_AUTH]: {
                title: 'Preguntas',
                className: 'sat-modal',
                image: {
                    className: 'questions-auth-img',
                    alt: 'Preguntas',
                    src: saQuestionsCheckImage,
                },
                button: {
                    text: 'Aceptar',
                    className: '',
                    onClick: this.triggerQuestions,
                },
                message: <>Para validar tu identidad <strong>te pedimos que contestes de forma correcta 5 preguntas</strong>.</>,
            },
            [this.CLAVE_UNICA_LOGIN]: {
                title: '',
                className: 'sat-modal',
                image: {
                    className: 'clave-unica-auth-img',
                    alt: 'Clave Única',
                    src: saUniqueKeyImage,
                },
                button: {
                    text: 'Iniciar sesión',
                    className: 'middlePrimaryButton',
                    onClick: this.loginClaveUnica,
                    image: {
                        className: 'icon-clave-unica',
                        alt: 'Icon Clave Única',
                        src: claveUnicaLogo,
                    },
                }
            },
        };
    }

    initModals() {
        return {
            [AM.CLAVE_UNICA_AUTH]: false,
            [AM.QUESTIONS_AUTH]: false,
            [this.CLAVE_UNICA_LOGIN]: false,
        };
    }

    componentDidMount() {
        this.props.setData({ AUTHENTICATION_TYPE: AM.CLAVE_UNICA_AUTH });
    }

    onClickModalTrigger(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.setData({ AUTHENTICATION_TYPE: AM.QUESTIONS_AUTH });
        if (this.VALID_VALUES.includes(AM.QUESTIONS_AUTH)) {
            const temp = {};
            temp[AM.QUESTIONS_AUTH] = true;
            const showModalsNew = { ...this.state.showModals, ...temp };
            this.setState({ showModals: showModalsNew });
        }
    }

    closeModal(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({ showModals: this.initModals() });
        this.props.setData({ AUTHENTICATION_TYPE: AM.CLAVE_UNICA_AUTH });
    }

    triggerQuestions(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({ showModals: this.initModals() });
        this.props.nextStep();
    }

    loginClaveUnica() {
        this.props.setData({ AUTHENTICATION_TYPE: AM.CLAVE_UNICA_AUTH });
        console.log(this.props)
        this.props.nextStep();
    }

    showModal() {
        const modalToShow = Object.keys(this.modalsInfo).find(key => this.state.showModals[key]);
        if (!modalToShow) {
            return '';
        }
        let modalInfo = this.modalsInfo[modalToShow];

        return (
            <Modal
                show={true}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                className={modalInfo.className}
                onHide={this.closeModal}
            >
                <div className={`message-modal-content`}>
                    <Modal.Header>
                        {<img src={modalInfo.image.src} className={modalInfo.image.className} alt={modalInfo.image.alt} />}
                        {modalInfo.title && <span className={'title'}>{modalInfo.title}</span>}
                        {<img src={saModalCloseImg} className={'close-modal'} alt={'Close'} onClick={this.closeModal} />}
                    </Modal.Header>
                    <Modal.Body>
                        <p className={'principal-message'}>{modalInfo.message}</p>
                    </Modal.Body>
                    <Modal.Footer style={{ textAlign: "center" }}>
                        {<Button onClick={modalInfo.button.onClick} className={modalInfo.button.className}>
                            {modalInfo.button.image &&
                                <img src={modalInfo.button.image.src}
                                    className={modalInfo.button.image.className}
                                    alt={modalInfo.button.image.alt} />} {modalInfo.button.text}
                        </Button>}
                        {modalInfo.hasOwnProperty('additionalLinks') && modalInfo.additionalLinks.length > 0
                            && modalInfo.additionalLinks.map((additionalLink, i) => {
                                return (<p key={`key-${i}`} className={additionalLink.className}>
                                    <a href={additionalLink.href} onClick={additionalLink.onClick}>{additionalLink.text}</a>
                                </p>);
                            })}
                    </Modal.Footer>
                </div>
            </Modal>
        );
    }

    render() {
        return (
            <div className={'select-authentication-type'}>
                <Grid>
                    <div className="content">
                        <Row className={'question'}>
                            <Col xs={12} >
                               Validación de identidad<br />
                               ClaveÚnica
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <p>
                                    Para validar tu identidad puedes hacerlo con tu ClaveÚnica. Si aún no la tienes, infórmate sobre cómo obtenerla en el sitio Web del Registro Civil o, si lo prefieres, presencialmente en sus oficinas o en sucursales de Chile Atiende.
                                </p>
                                <p>
                                    Se abrirá una nueva pantalla donde deberás ingresar tu RUT y ClaveÚnica.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <button className={this.modalsInfo[this.CLAVE_UNICA_LOGIN].button.className} onClick={this.modalsInfo[this.CLAVE_UNICA_LOGIN].button.onClick}>
                                   <img alt={this.modalsInfo[this.CLAVE_UNICA_LOGIN].button.image.alt} src={this.modalsInfo[this.CLAVE_UNICA_LOGIN].button.image.src}></img> {this.modalsInfo[this.CLAVE_UNICA_LOGIN].button.text}
                                </button>                      

                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                            <p className=''>
                                    <strong>Tendrás solo 5 minutos para iniciar sesión con tu ClaveÚnica.</strong>
                                </p>
                            </Col>
                        </Row>
                        <Row className=''>
                            <Col xs={12}>
                                <button className='btnLink' onClick={this.onClickModalTrigger}>¿Tienes problemas con ClaveÚnica?</button>
                            </Col>
                        </Row>
                        {this.showModal()}
                    </div>
                </Grid>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        data: state.data,
        stepData: state.stepData,
        showError: state.showError,
        errorType: state.errorType,
        errorMessage: state.errorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setData: (data) => {
            dispatch(setData(data));
        },
        setErrorMessage(errorMessage) {
            dispatch(setErrorMessage(errorMessage))
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAuthenticationTypeClaveUnicaPriority);
